import { Grid } from '@material-ui/core';
import { useTheme } from '@material-ui/styles';
import { Fragment } from 'react';

import { CustomPalette } from '../../config/types';
import { Text } from '../shared/components/Text';

export function NotFoundView() {
  const { palette }: { palette: CustomPalette } = useTheme();
  return (
    <Fragment>
      <Grid container justifyContent="center" className="appear-anim">
        <div style={{ textAlign: 'center' }}>
          <i
            className="material-icons-outlined mr-2"
            style={{ verticalAlign: 'text-top', fontSize: '160px', color: palette.grey[100] }}
          >
            warning
          </i>
          <br />
          <h5 style={{ color: palette.text.title }}>
            <Text tId={'PAGE_NOT_FOUND'} />
          </h5>
          <Text tId={'SORRY_THE_PAGE_DOES_NOT_EXIST'} />
        </div>
      </Grid>
    </Fragment>
  );
}
